import { apiRequest } from '../../api/client';
import { getApiToken } from '../../api/authToken';

export async function createShortLink({
  companyId,
  targetUrl,
  kind = 'other',
  context,
  ttlDays,
}) {
  const token = await getApiToken();
  return apiRequest(`/api/companies/${encodeURIComponent(companyId)}/short-links`, {
    token,
    method: 'POST',
    body: {
      targetUrl,
      kind,
      context,
      ttlDays,
    },
  });
}
